/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

export class JwtApiBase {
  AccessToken: Promise<string> | undefined

  protected readonly transformOptions = async (options: RequestInit): Promise<RequestInit> => {
    const token = await this.AccessToken

    options.headers = {
      ...options.headers,
      Authorization: `Bearer ${token}`,
    }

    return options
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  public readonly setAccessToken = (token: Promise<string>) => {
    this.AccessToken = token
  }
}

export interface ICompanyDataClientV2 {

    /**
     * Get a list of all companies
     * @param companyNames (optional) company name(s) to filter by
     * @param ssoDomain (optional) SSO Domain to filter by
     * @param search (optional) 
     * @param companyKey (optional) Company key to filter by
     * @return Success
     */
    getCompanies(pageNumber: number, pageSize: number, companyNames: string[] | undefined, ssoDomain: string | undefined, search: string | undefined, companyKey: string | undefined): Promise<Company[]>;

    /**
     * Allows creation of a new company.
     * @param body JSON structure that describes company info
     * @return Company successfully created. Company info can be found in response's body
     */
    createCompany(body: CompanyWithoutIdAndDefaultUserGroupId): Promise<Company>;

    /**
     * Returns information about company.
     * @param companyId Id of the company
     * @return Request succeeded. Company info can be found in response's body
     */
    getCompanyById(companyId: string): Promise<Company>;

    /**
     * Updates information about company.
     * @param companyId Id of the company
     * @param body Passed as PUT body
     * @return Request succeeded. Company info updated
     */
    updateCompany(companyId: string, body: CompanyWithoutId): Promise<void>;

    /**
     * Returns legacy Id for company
     * @param companyId Id of the company
     * @return Request succeeded. Company id can be found in the body.
     */
    getCompanyLegacyIdById(companyId: string): Promise<number>;

    /**
     * Returns default UserGroups for company
     * @param companyId Id of the company
     * @return Request succeeded. Default UserGroups can be found in the body.
     */
    getDefaultCompanyUserGroups(companyId: string): Promise<DefaultUserGroup[]>;

    /**
     * Adds a default UserGroup to a company
     * @param companyId Id of the company
     * @return Default UserGroup added.
     */
    addDefaultCompanyUserGroup(companyId: string, body: string): Promise<void>;

    /**
     * Removes a default UserGroup from a company
     * @param companyId Id of the company
     * @param userGroupId Id of the user group
     * @return Default UserGroup removed.
     */
    deleteDefaultCompanyUserGroup(companyId: string, userGroupId: string): Promise<void>;

    /**
     * Returns company image.
     * @param companyId Id of the company
     * @param fileName Name of the file (ShirtLogo.png/LibraryCard.png)
     * @param timestamp Encrypted timestamp
     * @return Retrieve the specified blob file
     */
    downloadCompanyImage(companyId: string, fileName: string, timestamp: string): Promise<FileResponse>;

    /**
     * Get a list of all companies current user has access to.
     * @param companyNames (optional) company name(s) to filter by
     * @return Success
     */
    getUserCompanies(pageNumber: number, pageSize: number, companyNames: string[] | undefined): Promise<UserCompany[]>;
}

export class CompanyDataClientV2 extends JwtApiBase implements ICompanyDataClientV2 {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/v2";
    }

    /**
     * Get a list of all companies
     * @param companyNames (optional) company name(s) to filter by
     * @param ssoDomain (optional) SSO Domain to filter by
     * @param search (optional) 
     * @param companyKey (optional) Company key to filter by
     * @return Success
     */
    getCompanies(pageNumber: number, pageSize: number, companyNames: string[] | undefined, ssoDomain: string | undefined, search: string | undefined, companyKey: string | undefined): Promise<Company[]> {
        let url_ = this.baseUrl + "/companies?";
        if (pageNumber === undefined || pageNumber === null)
            throw new Error("The parameter 'pageNumber' must be defined and cannot be null.");
        else
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (companyNames === null)
            throw new Error("The parameter 'companyNames' cannot be null.");
        else if (companyNames !== undefined)
            companyNames && companyNames.forEach(item => { url_ += "companyNames=" + encodeURIComponent("" + item) + "&"; });
        if (ssoDomain === null)
            throw new Error("The parameter 'ssoDomain' cannot be null.");
        else if (ssoDomain !== undefined)
            url_ += "ssoDomain=" + encodeURIComponent("" + ssoDomain) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (companyKey === null)
            throw new Error("The parameter 'companyKey' cannot be null.");
        else if (companyKey !== undefined)
            url_ += "CompanyKey=" + encodeURIComponent("" + companyKey) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCompanies(_response);
        });
    }

    protected processGetCompanies(response: Response): Promise<Company[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Company.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You do not have sufficient permissions to perform this action.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Company[]>(<any>null);
    }

    /**
     * Allows creation of a new company.
     * @param body JSON structure that describes company info
     * @return Company successfully created. Company info can be found in response's body
     */
    createCompany(body: CompanyWithoutIdAndDefaultUserGroupId): Promise<Company> {
        let url_ = this.baseUrl + "/companies";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateCompany(_response);
        });
    }

    protected processCreateCompany(response: Response): Promise<Company> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = Company.fromJS(resultData201);
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Model is invalid", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You do not have sufficient permissions to perform this action.", status, _responseText, _headers);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            return throwException("Company with specified CompanyName already exists", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Company>(<any>null);
    }

    /**
     * Returns information about company.
     * @param companyId Id of the company
     * @return Request succeeded. Company info can be found in response's body
     */
    getCompanyById(companyId: string): Promise<Company> {
        let url_ = this.baseUrl + "/companies/{companyId}";
        if (companyId === undefined || companyId === null)
            throw new Error("The parameter 'companyId' must be defined.");
        url_ = url_.replace("{companyId}", encodeURIComponent("" + companyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCompanyById(_response);
        });
    }

    protected processGetCompanyById(response: Response): Promise<Company> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Company.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("No Company found for given id.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Company>(<any>null);
    }

    /**
     * Updates information about company.
     * @param companyId Id of the company
     * @param body Passed as PUT body
     * @return Request succeeded. Company info updated
     */
    updateCompany(companyId: string, body: CompanyWithoutId): Promise<void> {
        let url_ = this.baseUrl + "/companies/{companyId}";
        if (companyId === undefined || companyId === null)
            throw new Error("The parameter 'companyId' must be defined.");
        url_ = url_.replace("{companyId}", encodeURIComponent("" + companyId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateCompany(_response);
        });
    }

    protected processUpdateCompany(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Failed to find a company in the database with a given identifier", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Returns legacy Id for company
     * @param companyId Id of the company
     * @return Request succeeded. Company id can be found in the body.
     */
    getCompanyLegacyIdById(companyId: string): Promise<number> {
        let url_ = this.baseUrl + "/companies/{companyId}/legacy-id";
        if (companyId === undefined || companyId === null)
            throw new Error("The parameter 'companyId' must be defined.");
        url_ = url_.replace("{companyId}", encodeURIComponent("" + companyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCompanyLegacyIdById(_response);
        });
    }

    protected processGetCompanyLegacyIdById(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("No Company found for given id.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(<any>null);
    }

    /**
     * Returns default UserGroups for company
     * @param companyId Id of the company
     * @return Request succeeded. Default UserGroups can be found in the body.
     */
    getDefaultCompanyUserGroups(companyId: string): Promise<DefaultUserGroup[]> {
        let url_ = this.baseUrl + "/companies/{companyId}/default-user-groups";
        if (companyId === undefined || companyId === null)
            throw new Error("The parameter 'companyId' must be defined.");
        url_ = url_.replace("{companyId}", encodeURIComponent("" + companyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDefaultCompanyUserGroups(_response);
        });
    }

    protected processGetDefaultCompanyUserGroups(response: Response): Promise<DefaultUserGroup[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DefaultUserGroup.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You do not have sufficient permissions to perform this action.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("No Company found for given id.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DefaultUserGroup[]>(<any>null);
    }

    /**
     * Adds a default UserGroup to a company
     * @param companyId Id of the company
     * @return Default UserGroup added.
     */
    addDefaultCompanyUserGroup(companyId: string, body: string): Promise<void> {
        let url_ = this.baseUrl + "/companies/{companyId}/default-user-groups/";
        if (companyId === undefined || companyId === null)
            throw new Error("The parameter 'companyId' must be defined.");
        url_ = url_.replace("{companyId}", encodeURIComponent("" + companyId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddDefaultCompanyUserGroup(_response);
        });
    }

    protected processAddDefaultCompanyUserGroup(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You do not have sufficient permissions to perform this action.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("No Company found for given id.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Removes a default UserGroup from a company
     * @param companyId Id of the company
     * @param userGroupId Id of the user group
     * @return Default UserGroup removed.
     */
    deleteDefaultCompanyUserGroup(companyId: string, userGroupId: string): Promise<void> {
        let url_ = this.baseUrl + "/companies/{companyId}/default-user-groups/{userGroupId}";
        if (companyId === undefined || companyId === null)
            throw new Error("The parameter 'companyId' must be defined.");
        url_ = url_.replace("{companyId}", encodeURIComponent("" + companyId));
        if (userGroupId === undefined || userGroupId === null)
            throw new Error("The parameter 'userGroupId' must be defined.");
        url_ = url_.replace("{userGroupId}", encodeURIComponent("" + userGroupId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteDefaultCompanyUserGroup(_response);
        });
    }

    protected processDeleteDefaultCompanyUserGroup(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You do not have sufficient permissions to perform this action.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("No Company found for given id.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Returns company image.
     * @param companyId Id of the company
     * @param fileName Name of the file (ShirtLogo.png/LibraryCard.png)
     * @param timestamp Encrypted timestamp
     * @return Retrieve the specified blob file
     */
    downloadCompanyImage(companyId: string, fileName: string, timestamp: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/companies/{companyId}/images/{fileName}?";
        if (companyId === undefined || companyId === null)
            throw new Error("The parameter 'companyId' must be defined.");
        url_ = url_.replace("{companyId}", encodeURIComponent("" + companyId));
        if (fileName === undefined || fileName === null)
            throw new Error("The parameter 'fileName' must be defined.");
        url_ = url_.replace("{fileName}", encodeURIComponent("" + fileName));
        if (timestamp === undefined || timestamp === null)
            throw new Error("The parameter 'timestamp' must be defined and cannot be null.");
        else
            url_ += "timestamp=" + encodeURIComponent("" + timestamp) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDownloadCompanyImage(_response);
        });
    }

    protected processDownloadCompanyImage(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("No company file found for given id.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Invalid timestamp.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(<any>null);
    }

    /**
     * Get a list of all companies current user has access to.
     * @param companyNames (optional) company name(s) to filter by
     * @return Success
     */
    getUserCompanies(pageNumber: number, pageSize: number, companyNames: string[] | undefined): Promise<UserCompany[]> {
        let url_ = this.baseUrl + "/users/me/companies?";
        if (pageNumber === undefined || pageNumber === null)
            throw new Error("The parameter 'pageNumber' must be defined and cannot be null.");
        else
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (companyNames === null)
            throw new Error("The parameter 'companyNames' cannot be null.");
        else if (companyNames !== undefined)
            companyNames && companyNames.forEach(item => { url_ += "companyNames=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUserCompanies(_response);
        });
    }

    protected processGetUserCompanies(response: Response): Promise<UserCompany[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserCompany.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserCompany[]>(<any>null);
    }
}

export class CompanyBase implements ICompanyBase {
    companyName!: string;
    companyIconURL?: string | undefined;
    headerIconURL?: string | undefined;
    showroomRoomId?: string | undefined;
    isPartnerCompany!: boolean;
    isVisibleToExternalUsers?: boolean;
    friendlyName!: string;
    sSODomain?: string;

    constructor(data?: ICompanyBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.isPartnerCompany = false;
            this.isVisibleToExternalUsers = true;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyName = _data["CompanyName"];
            this.companyIconURL = _data["CompanyIconURL"];
            this.headerIconURL = _data["HeaderIconURL"];
            this.showroomRoomId = _data["ShowroomRoomId"];
            this.isPartnerCompany = _data["IsPartnerCompany"] !== undefined ? _data["IsPartnerCompany"] : false;
            this.isVisibleToExternalUsers = _data["IsVisibleToExternalUsers"] !== undefined ? _data["IsVisibleToExternalUsers"] : true;
            this.friendlyName = _data["FriendlyName"];
            this.sSODomain = _data["SSODomain"];
        }
    }

    static fromJS(data: any): CompanyBase {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CompanyName"] = this.companyName;
        data["CompanyIconURL"] = this.companyIconURL;
        data["HeaderIconURL"] = this.headerIconURL;
        data["ShowroomRoomId"] = this.showroomRoomId;
        data["IsPartnerCompany"] = this.isPartnerCompany;
        data["IsVisibleToExternalUsers"] = this.isVisibleToExternalUsers;
        data["FriendlyName"] = this.friendlyName;
        data["SSODomain"] = this.sSODomain;
        return data;
    }
}

export interface ICompanyBase {
    companyName: string;
    companyIconURL?: string | undefined;
    headerIconURL?: string | undefined;
    showroomRoomId?: string | undefined;
    isPartnerCompany: boolean;
    isVisibleToExternalUsers?: boolean;
    friendlyName: string;
    sSODomain?: string;
}

export class Company extends CompanyBase implements ICompany {
    companyId!: string;
    companyKey?: string;
    libraryCardURL?: string | undefined;
    shirtLogoURL?: string | undefined;
    defaultUserGroupId?: string;

    constructor(data?: ICompany) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.companyId = _data["CompanyId"];
            this.companyKey = _data["CompanyKey"];
            this.libraryCardURL = _data["LibraryCardURL"];
            this.shirtLogoURL = _data["ShirtLogoURL"];
            this.defaultUserGroupId = _data["DefaultUserGroupId"];
        }
    }

    static fromJS(data: any): Company {
        data = typeof data === 'object' ? data : {};
        let result = new Company();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CompanyId"] = this.companyId;
        data["CompanyKey"] = this.companyKey;
        data["LibraryCardURL"] = this.libraryCardURL;
        data["ShirtLogoURL"] = this.shirtLogoURL;
        data["DefaultUserGroupId"] = this.defaultUserGroupId;
        super.toJSON(data);
        return data;
    }
}

export interface ICompany extends ICompanyBase {
    companyId: string;
    companyKey?: string;
    libraryCardURL?: string | undefined;
    shirtLogoURL?: string | undefined;
    defaultUserGroupId?: string;
}

export class UserCompany extends Company implements IUserCompany {
    hasContentAccess!: boolean;

    constructor(data?: IUserCompany) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.hasContentAccess = false;
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.hasContentAccess = _data["HasContentAccess"] !== undefined ? _data["HasContentAccess"] : false;
        }
    }

    static fromJS(data: any): UserCompany {
        data = typeof data === 'object' ? data : {};
        let result = new UserCompany();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["HasContentAccess"] = this.hasContentAccess;
        super.toJSON(data);
        return data;
    }
}

export interface IUserCompany extends ICompany {
    hasContentAccess: boolean;
}

export class CompanyWithoutId extends CompanyBase implements ICompanyWithoutId {
    libraryCard?: string | undefined;
    shirtLogo?: string | undefined;
    defaultUserGroupId?: string;

    constructor(data?: ICompanyWithoutId) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.libraryCard = _data["LibraryCard"];
            this.shirtLogo = _data["ShirtLogo"];
            this.defaultUserGroupId = _data["DefaultUserGroupId"];
        }
    }

    static fromJS(data: any): CompanyWithoutId {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyWithoutId();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["LibraryCard"] = this.libraryCard;
        data["ShirtLogo"] = this.shirtLogo;
        data["DefaultUserGroupId"] = this.defaultUserGroupId;
        super.toJSON(data);
        return data;
    }
}

export interface ICompanyWithoutId extends ICompanyBase {
    libraryCard?: string | undefined;
    shirtLogo?: string | undefined;
    defaultUserGroupId?: string;
}

export class CompanyWithoutIdAndDefaultUserGroupId extends CompanyBase implements ICompanyWithoutIdAndDefaultUserGroupId {
    libraryCard?: string | undefined;
    shirtLogo?: string | undefined;

    constructor(data?: ICompanyWithoutIdAndDefaultUserGroupId) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.libraryCard = _data["LibraryCard"];
            this.shirtLogo = _data["ShirtLogo"];
        }
    }

    static fromJS(data: any): CompanyWithoutIdAndDefaultUserGroupId {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyWithoutIdAndDefaultUserGroupId();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["LibraryCard"] = this.libraryCard;
        data["ShirtLogo"] = this.shirtLogo;
        super.toJSON(data);
        return data;
    }
}

export interface ICompanyWithoutIdAndDefaultUserGroupId extends ICompanyBase {
    libraryCard?: string | undefined;
    shirtLogo?: string | undefined;
}

export class DefaultUserGroup implements IDefaultUserGroup {
    userGroupId!: string;
    companyId!: string;
    isPrimaryGroup!: boolean;

    constructor(data?: IDefaultUserGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userGroupId = _data["UserGroupId"];
            this.companyId = _data["CompanyId"];
            this.isPrimaryGroup = _data["IsPrimaryGroup"];
        }
    }

    static fromJS(data: any): DefaultUserGroup {
        data = typeof data === 'object' ? data : {};
        let result = new DefaultUserGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["UserGroupId"] = this.userGroupId;
        data["CompanyId"] = this.companyId;
        data["IsPrimaryGroup"] = this.isPrimaryGroup;
        return data;
    }
}

export interface IDefaultUserGroup {
    userGroupId: string;
    companyId: string;
    isPrimaryGroup: boolean;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

/* tslint:disable */
/* eslint-disable */